export default __webpack_public_path__ + "static/media/Print_certificate_Sp_2025_April.429588c1.jpeg";